import React from 'react';
import './ui.scss';

export const Loader = ({ label = 'Loading...' }) => (
  <div className="builder-ui-loader" role="status" aria-live="polite">
    <span className="builder-ui-loader__spinner" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

export default Loader;
